import { BareButton } from '@calendly/ui/components/bare-button'
import styled from 'astroturf/react'
import { BrandLogo } from '@calendly/ui/components/brand-logo'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const fontSizeLabelSmall = 'var(--fontSizeLabelSmall, 0.6875rem)'

import { useI18n } from 'locales'
import _StyledBadge from "badge-StyledBadge.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/payment/stripe/badge.js?styleId=StyledBadge";
import _StyledBrandLogo from "badge-StyledBrandLogo.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/payment/stripe/badge.js?styleId=StyledBrandLogo";


const StyledBadge = /*#__PURE__*/styled(BareButton, null, {
  displayName: "StyledBadge",
  styles: _StyledBadge,
  attrs: props => ({
    ...props,
    as: 'a'
  })
})

const StyledBrandLogo = /*#__PURE__*/styled(BrandLogo, null, {
  displayName: "StyledBrandLogo",
  styles: _StyledBrandLogo
})

const Badge = () => {
  const { i18n } = useI18n()
  return (
    <StyledBadge
      href="https://stripe.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      {i18n.t('booking.invitee.powered_by')}
      <StyledBrandLogo name="stripe" alt="Stripe" />
    </StyledBadge>
  )
}

export default Badge
